module.exports = __webpack_public_path__ + "static/media/globe-fill.2a4fc859.svg";